import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ResRobotFetchTrip } from '@ridango/components';
import { OnDemandPublicTrip } from '@ridango/core/lib/ridango.models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ScheduleService {
    constructor(@Inject('ENV') private env: any, private http: HttpClient, private datePipe: DatePipe) {}

    fetchRouteList() {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/transit/routes`;

        return this.http.get(url);
    }

    fetchRouteStopsList(routeId, directionId) {
        const url =
            directionId
                ? `${this.env.API_BASE_URL}/${this.env.REGION_ID}/transit/route/${routeId}/direction/${directionId}/stops`
                : `${this.env.API_BASE_URL}/${this.env.REGION_ID}/transit/route/${routeId}/stops`;

        return this.http.get(url);
    }

    fetchStopsWithRoutes() {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/transit/stops_with_routes`;

        return this.http.get(url);
    }

    fetchRoutePolyline(routeId, directionId) {
        const url =
            !!directionId && directionId !== '0'
                ? `${this.env.API_BASE_URL}/${this.env.REGION_ID}/routes/${routeId}/direction/${directionId}/shapes/polyline`
                : `${this.env.API_BASE_URL}/${this.env.REGION_ID}/routes/${routeId}/shapes/polyline`;

        return this.http.get(url);
    }

    fetchRouteStopDeparturesList(routeId, stopId) {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/transit/route/${routeId}/stop/${stopId}/schedule`;

        return this.http.get(url);
    }

    fetchRouteTrip(tripId) {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/transit/trip/${tripId}/stops`;

        return this.http.get(url);
    }

    fetchStopList(location) {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/resrobot/location-name`;

        const formData = new FormData();
        formData.append('location', encodeURIComponent(location));

        return this.http.post(url, formData);
    }

    fetchPlannerTrip(trip: ResRobotFetchTrip) {
        const date = this.datePipe.transform(trip.date, 'yyyy-MM-dd');
        const time = this.datePipe.transform(trip.date, 'HH:mm');

        const url = new URL(
            `${this.env.API_BASE_URL}/${this.env.REGION_ID}/resrobot/trip?format=json&date=${date}&time=${time}&searchForArrival=${trip.priority}`
        );
        const urlParams = url.searchParams;

        if (trip.originId) {
            urlParams.append('originId', `${trip.originId}`);
        } else {
            urlParams.append('originCoordLat', `${trip.originLat}`);
            urlParams.append('originCoordLong', `${trip.originLng}`);
        }

        if (trip.destId) {
            urlParams.append('destId', `${trip.destId}`);
        } else {
            urlParams.append('destCoordLat', `${trip.destLat}`);
            urlParams.append('destCoordLong', `${trip.destLng}`);
        }

        return this.http.get(url.toString());
    }

    fetchOnDemandPublicRoutes(date) {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/ondemand/scheduling/public/trips/date/${date}`;

        return this.http.get<OnDemandPublicTrip[]>(url);
    }

    fetchUpcomingTrips(): Observable<OnDemandPublicTrip[]> {
        const url = `${this.env.CORE_API_URL}/customer/v3/region/${this.env.REGION_ID}/ondemand/trips`;
        const options = {
            headers: new HttpHeaders({
                'Accept': 'application/json'
            })
        };

        return this.http.get<OnDemandPublicTrip[]>(url, options);
    }
}
